<template>

      <v-dialog
        v-model="dialog"
        width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="red lighten-2"
            dark
            v-bind="attrs"
            v-on="on"
          >
            MODO DE USO
          </v-btn>
        </template>
  
        <v-card >
          <v-card-title class="headline">
            Hola <v-icon>mdi-hand-peace</v-icon>
          </v-card-title>
          <v-card-subtitle >
            Recuerda estos pasos para crear y enviar tu pedido:
          </v-card-subtitle>
          <v-divider class="mb-3"></v-divider>
          <v-card-text>
            <v-icon color="danger">mdi-numeric-1-circle</v-icon>
            Es necesario activar WhatsApp Web, para que puedas enviar el pedido. <a class="red--text">(solo para computadores)</a>
          </v-card-text>
          
          <v-card-text>
            <v-icon color="danger">mdi-numeric-2-circle</v-icon>
            Agrega al carrito los productos que deseas comprar
          </v-card-text>
  
          <v-card-text>
            <v-icon color="danger">mdi-numeric-3-circle</v-icon>
             Al confirmar tu pedido, serás redireccionado a WhatsApp con un mensaje predeterminado a enviar 
          </v-card-text>
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Entendido
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

</template>

<script>

export default {
    data(){
        return {
            dialog : false
        }
    },
    mounted(){
       // this.isMobile()
    },
    methods : {  
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.dialog = false
            } else {
                this.dialog = true
            }
        }
    }
}
</script>
